<!--     todo remove force light-->
<div data-mode="light">
  <header>
    <download-header></download-header>
  </header>
  <main role="main">
    <section class="landing-page-section--hero">
      <landing-hero></landing-hero>
      <div
        sectionSlice
        class="hero-slice"
        [bottom]="'-1px'"
        [customSliceUrl]="'/assets/images/landing/hero/landing-hero-bottom-slice.svg'"
      ></div>
    </section>
    <section class="section landing-page-section--earn">
      <div class="container">
        <landing-earn></landing-earn>
      </div>
      <div
        *ngIf="foodLandingChains?.length"
        sectionSlice
        bgColor="#ffb522"
        [bottom]="'-1px'"
        [customSliceUrl]="'/assets/images/landing/earn/landing-earn-bottom-slice.svg'"
      ></div>
    </section>
    <section *ngIf="foodLandingChains?.length" class="section landing-page-section--brands">
      <div class="container landing-page-container--brands">
        <h2>
          <span>{{'discover_more_than_shops' | translate}}</span>
          <br />
          <span>{{'shops_in_x_cities' | translate}} </span>
        </h2>
        <div class="brands-container">
          <landing-chains [landingChains]="foodLandingChains"></landing-chains>
        </div>
      </div>
      <div
        *ngIf="groceriesLandingChains?.length"
        sectionSlice
        class="brands-slice"
        [bottom]="'-1px'"
        [customSliceUrl]="'/assets/images/landing/brands/landing-brands-bottom-slice.svg'"
      ></div>
    </section>
    <section *ngIf="groceriesLandingChains?.length" class="section landing-page-section--super-markets">
      <div class="container landing-page-container--super-markets">
        <h2>
          <span>{{'make_purchase_online' | translate}} </span>
          <br />
          <span>{{'more_than_x_items' | translate}} </span>
        </h2>
        <div class="brands-container">
          <landing-chains [landingChains]="groceriesLandingChains"></landing-chains>
        </div>
      </div>
      <div
        sectionSlice
        [flip]="true"
        [bottom]="'-110px'"
        class="super-markets-slice"
        [customSliceUrl]="'/assets/images/landing/brands/landing-brands-bottom-slice.svg'"
      ></div>
    </section>
    <section class="landing-page-section--merchants">
      <picture class="landing-page-section--merchants-image">
        <source
          type="image/webp"
          srcset="
            /assets/images/landing/merchants/@1xlanding-merchants-bg.webp 1x,
            /assets/images/landing/merchants/@2xlanding-merchants-bg.webp 2x,
            /assets/images/landing/merchants/@3xlanding-merchants-bg.webp 3x
          "
          alt="Landing merchants"
        />

        <source
          type="image/png"
          srcset="
            /assets/images/landing/merchants/@1xlanding-merchants-bg.jpg 1x,
            /assets/images/landing/merchants/@2xlanding-merchants-bg.jpg 2x,
            /assets/images/landing/merchants/@3xlanding-merchants-bg.jpg 3x
          "
          alt="Landing merchants"
        />

        <img
          src="/assets/images/landing/merchants/@3xlanding-merchants-bg.jpg"
          srcset="
            /assets/images/landing/merchants/@1xlanding-merchants-bg.jpg 1x,
            /assets/images/landing/merchants/@2xlanding-merchants-bg.jpg 2x,
            /assets/images/landing/merchants/@3xlanding-merchants-bg.jpg 3x
          "
          alt="Landing merchants"
          loading="lazy"
        />
      </picture>
      <div class="container landing-page-container--merchants">
        <landing-merchants></landing-merchants>
      </div>
    </section>
    <section class="section landing-page-section--download">
      <div class="container">
        <box-download></box-download>
      </div>
    </section>
    <section class="section landing-page-section--cuisines">
      <div class="container">
        <landing-cuisines></landing-cuisines>
      </div>
    </section>
    <section class="section landing-page-section--areas">
      <div class="container">
        <landing-locations></landing-locations>
      </div>
    </section>
  </main>
  <box-footer></box-footer>
</div>
